<div class="files-preview-container">

  <div class="file-input">
      <div class="image-uploader" [ngClass]="{'no-image': noImage, 'square-wide': wideSquareImage }">
          <div class="upload-container">
              <label [attr.for]="'fileDropRef_' + managerIndex">
                  <input #fileDropRef type="file"
                      (change)="fileSelected($event)"
                      accept=".png, .jpeg, .jpg"
                      (click)="fileDropRef.value = ''"
                      [disabled]="isDisabled"
                      [hidden]="true"
                      [multiple]="false"
                      [attr.id]="'fileDropRef_' + managerIndex" />
                  <div class="image-preview camera-fill photo" [ngClass]="squareImage ? 'squared' : ''">
                    <ng-container *ngIf="src">
                      <img [src]="src" alt="" class="bg-light">
                    </ng-container>
                  </div>

              </label>
          </div>
          <div>
              <label>{{label}}<span class="optional" *ngIf="optional">({{'forms.Optional' | translate}})</span></label>
              <h2 [hidden]="!title">{{title}}</h2>
              <h2 [hidden]="!description">{{description}}</h2>
              <p>
                <span>({{ 'forms.MB max' | translate: {no: maxSize} }})</span>
                  {{ allowedExtTxt }}
              </p>
              <label [attr.for]="'fileDropRef_' + managerIndex">
                  <a>{{'forms.Upload/Select File' | translate }}</a>
              </label>

          </div>
      </div>
  </div>

  <div *ngIf="!src && isRequired && isSubmited" class="has-error">{{"forms.Required" | translate}} </div>
  <div *ngIf="fileErrors.type" class="has-error">
    {{"fileManager.Invalid File Extensions" | translate}}
  </div>
  <div *ngIf="fileErrors.size" class="has-error">
    {{ "fileManager.Max File Size" | translate: { maxFileSize: maxSize } }}
  </div>
</div>
